export default __webpack_public_path__ + "static/media/line_kidney.d42c526b.png";